import { useTranslation } from "react-i18next";
import { useGetAttendedClassEventsReservationsQuery } from "../../../api/queries/classEvent/useGetAttendedClassEventsReservationsQuery";
import { TAttendedClassEvent } from "../../../models/ClassEvent";
import { useState } from "react";
import { useNavigate } from "react-router";

const DEFAULT_ATTENDED_ARRAY = [] as TAttendedClassEvent[];

export const useAttended = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [selectedEvent, setSelectedEvent] = useState<TAttendedClassEvent | null>(null);

  const {
    data: attendedClassEvents = DEFAULT_ATTENDED_ARRAY,
    isLoading,
    refetch,
  } = useGetAttendedClassEventsReservationsQuery();

  const onLeaveAReview = (classEvent: TAttendedClassEvent) => {
    if (!classEvent) return;

    setSelectedEvent(classEvent);
  };

  const onCloseLeaveAReview = () => setSelectedEvent(null);

  const onClickGymImage = (id: string) => {
    if (!id) return;

    navigate(`/gyms-location/${id}`);
  };

  const onSuccessLeaveARating = () => {
    setSelectedEvent(null);
    refetch();
  };

  return {
    t,
    selectedEvent,
    attendedClassEvents,
    isLoading,
    onClickGymImage,
    onLeaveAReview,
    onCloseLeaveAReview,
    onSuccessLeaveARating,
  };
};
